import { render, staticRenderFns } from "./UploadHistory.vue?vue&type=template&id=60bfa5f5&scoped=true&"
import script from "./UploadHistory.vue?vue&type=script&lang=js&"
export * from "./UploadHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bfa5f5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60bfa5f5')) {
      api.createRecord('60bfa5f5', component.options)
    } else {
      api.reload('60bfa5f5', component.options)
    }
    module.hot.accept("./UploadHistory.vue?vue&type=template&id=60bfa5f5&scoped=true&", function () {
      api.rerender('60bfa5f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploads/views/UploadHistory.vue"
export default component.exports